import Outline from './Outline';


/**
 * @type { import('didi').ModuleDeclaration }
 */
export default {
  __init__: [ 'outline' ],
  outline: [ 'type', Outline ]
};